module.exports = __webpack_public_path__ + "static/media/clients-05.707940d6.svg";